import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const blogCategoryServices = {
  addNewBlogCategory,
  updatedBlogCategory,
  softDeleteRestoreBlogCategory,
  deleteBlogCategory,
  getBlogCategoryList,
};

// Add New Blog Category
async function addNewBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Blog Category
async function updatedBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Blog Category
async function softDeleteRestoreBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Blog Category
async function deleteBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Blog Category
async function getBlogCategoryList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getBlogCategoryList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogCategoryList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogCategoryList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}